<template>
  <div
    class="w-full border border-black/8 shdw rounded-xl p-[22px] pr-[18px] font-secondary text-[14px] leading-[22px] text-gray-800 text-left"
  >
    <div class="mb-4">{{ props.quote }}</div>

    <div class="flex items-start justify-between">
      <div class="text-[12px] leading-normal flex items-center">
        <Avatar :src="props.author.avatarUrl" :size="30" class="mr-1.5" />

        <div>
          <div class="font-medium">{{ props.author.name }}</div>
          <div>{{ props.author.title }}</div>
        </div>
      </div>

      <div class="flex items-center gap-x-[3px]">
        <StarIcon v-for="n in 5" :key="n" class="size-[15px]" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Avatar } from '@dacr/ui'
import StarIcon from '@/assets/svg/icons/StarIcon.svg'

const props = defineProps<{
  quote: string
  author: {
    avatarUrl: string
    name: string
    title: string
  }
}>()
</script>

<style scoped>
.shdw {
  box-shadow:
    0 4px 18px 0 rgba(0, 0, 0, 0.04),
    0 0.8px 2.93px 0 rgba(0, 0, 0, 0.02);
}
</style>
